import React from "react";
import * as Rb from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {Link } from "react-router-dom";
import * as Bs from "react-icons/bs";
import * as Gi from "react-icons/gi";
import * as Ai from "react-icons/ai";
import * as Fa from "react-icons/fa";
class footer extends React.Component
{
    render(){
        return(
            <div>
                <section class="d-block d-sm-none">
                    <Rb.Row>
                        <Rb.Col sm={12} md={12} lg={12}>
                            <Rb.Navbar className="py-0 footer_menu">
                                <Rb.Container className="p-0">
                                    <Rb.Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                    <Rb.Navbar.Collapse id="responsive-navbar-nav">
                                        <Rb.Card className="ms-auto nav_head">
                                            <Rb.Nav className="fnav_align shadow py-2 nav_head">
                                                <Link to="/about" className="m-2"><Bs.BsPersonCircle/></Link>
                                                <Link to="/resume" className="m-2"><Bs.BsFileCheck/></Link>
                                                <Link to="/skill" className="m-2"><Gi.GiSkills/></Link>
                                                <Link to="/project" className="m-2"><Ai.AiOutlineFundProjectionScreen/></Link>
                                                <Link to="/ed_ex" className="m-2"><Fa.FaGraduationCap/></Link>
                                                <Link to="/contact" className="m-2"><Bs.BsTelephone/></Link>
                                            </Rb.Nav>
                                        </Rb.Card>
                                    </Rb.Navbar.Collapse>
                                </Rb.Container>
                            </Rb.Navbar>
                        </Rb.Col>
                    </Rb.Row>
                </section>
            </div>
        )
    }
}
export default footer